/* Component Dependencies */
var localPartnersTemplate = require('templates/localPartners.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'localPartners',
  template: {
    'localPartners': localPartnersTemplate
  }
});
